export default {
  noLikesFound: 'No likes found',
  noMusicalGenresFound: 'There aren´t musical genres yet',
  noArtistsFound: 'There aren´t artists yet',
  noSongsFound: 'There aren´t songs yet',
  extraData: 'Additional information',
  noExtraDataFound: 'There isn´t additional information',
  typeOfRegister: 'Type of register',
  createList: 'Create list',
  import: 'Import',
  invitations: 'Invitations',
  invite: 'Invite',
  seeGuests: 'See guests',
  addNew: 'Add new',
  mustChargeBeforeCreatePeople: 'You must charge money before creating people',
  invited: 'Invited',
  verified: 'Verified',
  notVerified: 'Not verified',
  imported: 'Imported',
  notImported: 'Not imported',
  oneTimePassword: 'One time password',
  changePassword: 'Change password',
  deletePerson: 'Delete person',
  loading: 'Loading',
  noPeopleRegistered: 'No people registered',
  emailOrPhone: 'Email or phone',
  method: 'Method',
  creationDate: 'Creation date',
  actions: 'Actions',
  customizedSearch: 'Customized search',
  state: 'State',
  createPerson: 'Create person',
  perPage: 'per page',
  loadFile: 'Load file',
  organizeData: 'Organize data',
  verify: 'Verify',
  pickToImportBusinessesOrPeopleToNewList: 'Pick if you want to import businesses or people to a new or existent list',
  pickToSavePeopleToList: 'Pick if you want to save the people that you are importing into a list',
  business: 'Business',
  existentList: 'Existent list',
  newList: 'New list',
  noList: 'Without list',
  listsNotCreated: 'You haven´t created any list',
  pickAList: 'Pick a list',
  typeNameOfTheList: 'Type the list name',
  uploadFileTypeInfo: 'Upload the file where you have your contacts saved in CSV or xlsx format',
  pickFile: 'Pick file',
  identifyImportedFields: 'Identify each field based in the info that it is going to contain',
  newColumnName: 'New column name',
  verifyInfoBeforeListCreation: 'Verify that the information is correct before creating the list',
  cancel: 'Cancel',
  goBack: 'Go back',
  continue: 'Continue',
  message: 'Message',
  other: 'Other',
  contact: 'Contact',
  company: 'Company',
  address: 'Address',
  document: 'Document',
  image: 'Image',
  location: 'Location',
  observation: 'Observation',
  position: 'Position',
  phone: 'Phone',
  phonePaste: 'Paste phone number',
  phoneWrite: 'Write phone number',
  validPhone: 'Valid phone number',
  invalidPhone: 'Invalid phone',
  switchPasteModePhone: 'Switch to paste-mode phone input',
  switchWriteModePhone: 'Switch to write-mode phone input',
  pickWhereToSavePeopleToImport: 'Pick where to save the people that you are going to import',
  pleaseAddAValidFile: 'Please add a valid file',
  errorReadingTheFile: 'There was an error reading the file',
  newPerson: 'New person',
  password: 'Password',
  addNewPerson: 'Add new person',
  personSuccessfullyAdded: 'Person successfully added',
  sendEmailTo: 'Send email to',
  sendSMSTo: 'Send SMS to',
  call: 'Call',
  downloadContact: 'Download contact',
  editUser: 'Edit user',
  know: 'Know',
  connect: 'Connect',
  emailVerify: 'Email Verify',
  talk: 'Talk',
  tasks: 'Tasks',
  record: 'Actions',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: 'Add person Email or phone to send notifications about the task status',
  observations: 'Observations',
  editTask: 'Edit task',
  youMustAddTheNameOfTheTask: 'You must add the name of the task',
  sameNameTask: 'A task with this name already exists',
  taskSuccessfullyDeleted: 'Task deleted successfully',
  noPersonNotes: 'This user has no saved notes',
  insertNewNote: 'Insert a new note',
  currentNotes: 'Saved notes',
  editNote: 'Edit this note',
  deleteNote: 'Delete this note',
  errorUpdatingNotes: 'Notes could not be updated',
  clickPendingTasks: 'Click to see tasks details',
  tasksList: 'Tasks list',
  tasksDueToday: 'Due Today',
  tasksDueAfter: 'Due After',
  tasksDueBefore: 'Due Before',
  daysRemaining: 'Remaining days',
  extraManagementAddNewField: 'Add new field of information',
  extraManagementAditionalInfo: 'Additional information from people of your brand',
  extraManagementItemAccessApplication: 'Can only be seen by an admin of this application',
  extraManagementItemAccessPerson: 'Can be seen by the people',
  extraCreatorShortText: 'Short text field',
  extraCreatorLongText: 'Large text field',
  extraCreatorList: 'Dropdown list',
  extraCreatorRadioList: 'Radio button list',
  extraCreatorCheckList: 'Checkbox list',
  extraCreatorEmail: 'E-mail',
  extraCreatorCreateField: 'Create an aditional information field',
  extraCreatorEditField: 'Edit an aditional information field',
  extraCreatorFieldName: 'Name of the field',
  extraCreatorFieldType: 'Type of the field',
  extraCreatorFieldAccess: 'Access of the field',
  extraCreatorAddOptions: 'Add the options',
  extraCreatorOption: 'Option',
  extraCreatorApplication: 'Aplication',
  extraCreatorApplicationInfo: 'Allow the application to visualize and modify this field from the administrator',
  extraCreatorPersonInfo: 'Allows users to visualize and modify this field from their profile',
  extraCreatorAddTags: 'Add some tags',
  extraCreatorMessageEnterTag1: 'No results matching',
  extraCreatorMessageEnterTag2: 'Press',
  extraCreatorMessageEnterTag3: 'to create a new one',
  setResponsible: 'Set a responsible',
  assign: 'Assign',
  selectResponsible: 'Select responsible for this list of new users',
  pickAResponsible: 'Pick a responsible',
  selectResponsibleSolo: 'Select a responsible for this user',
  seeLess: 'See less',
  favoriteSongs: 'Favorite songs',
  favoriteMusicalGenres: 'Favorite musical genres',
  favoriteArtists: 'Favorite artists',
  noInstagramSpotifyTags: 'There aren´t Instagram or Spotify preferences yet',
  addToList: 'Add to list',
  noPersonRecords: 'This user doesn´t have an actions record',
  personAddedToList: 'Person added to list',
  messageSuccessfullySent: 'Message successfully sent',
  loadCsv: 'Load CSV',
  insertInvitedPeopleEmailPhone: 'Insert all the emails or phones of the people that you want to invite separated by commas',
  noEmail: 'Without email',
  noPhone: 'Without phone',
  noLoadedInvitations: 'No loaded invitations',
  downloadCsv: 'Download CSV',
  invitePerson: 'Invite person',
  inviteAdministrator: 'Invite user',
  invitedPeople: 'Invited people',
  sendSms: 'Send SMS',
  resendInvitations: 'Resend invitations',
  noInvitationsSent: 'No invitations sent',
  noAssistantSelected: 'You haven´t selected any assistant',
  thisEmailIsGoingToBeSentTo: 'This email is going to be sent to',
  assistants: 'Assistants',
  noPersonSelected: 'You haven´t selected any person',
  allTheEventAssistants: 'all the {event} assistants',
  close: 'Close',
  send: 'Send',
  accept: 'Accept',
  actualPassword: 'Actual password',
  change: 'Change',
  youAreAboutToChangeUserPassword: 'You are about to change {user}´s password, remember to tell the person the new password',
  saveChanges: 'Save changes',
  onetimePasswordUse: 'This password can be only used one time',
  sendToPersonEmail: 'Send to person\'s email',
  sendToPersonPhone: 'Send to person\'s phone',
  generatePassword: 'Generate password',
  passwordCopiedToClipboard: 'The password has been copied to the clipboard',
  errorCopyingThePassword: 'Error copying the password',
  doYouWantToDeleteThisPerson: 'Do you want to delete this person?',
  personSuccessfullyDeleted: 'Person successfully deleted',
  selectFinishingDate: 'Select the expected finishing date',
  pick: 'Pick',
  selectFinishingHour: 'Select task\'s expected finishing hour',
  createTask: 'Create task',
  currentTasks: 'Current tasks',
  noTasksToDo: 'There are not tasks to do',
  hour: 'Hour',
  date: 'Date',
  moveToDoneTasks: 'Move to done tasks',
  deleteTask: 'Delete task',
  completedTasks: 'Completed tasks',
  noCompletedTasks: 'There are not completed tasks',
  moveToUndoneTasks: 'Move to undone tasks',
  errorUpdatingTasks: 'Could not update tasks',
  enterTheNameAndDescriptionOfTheTask: 'Enter the name and observations of the task',
  insertANewTask: 'Create a new task',
  editProfile: 'Edit profile',
  insertFullName: 'Insert your full name',
  insertYourEmail: 'Insert your email',
  addRoles: 'Add tags',
  description: 'Description',
  userDescription: 'User description',
  notes: 'Notes',
  addCommentsAboutThisPerson: 'Add comments about this person',
  noInformation: 'No information',
  updatedCorrectly: 'Updated correctly',
  searchCountry: 'Search country',
  countryNotFound: 'Country not found',
  uploadDocument: 'Upload document',
  downloadDocument: 'Download document',
  editDocument: 'Edit document',
  deleteDocument: 'Delete document',
  documents: 'Documents',
  deleteDocumentConfirmation: 'Do you really want to delete this document?',
  insertDocumentDescription: 'Enter the document description',
  editDescription: 'Edit description',
  documentSuccessfullyDeleted: 'Document successfully deleted',
  youMustPickADocumentToEdit: 'You must pick a document to edit',
  fileSizeMustBeUnderXSize: 'The attached file size must be under {size}',
  documentSuccessfullyEdited: 'Document successfully deleted',
  documentSuccessfullyUploaded: 'Document successfully uploaded',
  editList: 'Edit list',
  listCorrectlyUpdated: 'List updated correctly',
  personDeletedFromList: 'Person deleted from list',
  doYouWantToDeleteThisList: 'Do you want to delete this list',
  deleteList: 'Delete list',
  listDeleted: 'List deleted',
  lists: 'Lists',
  create: 'Create',
  campaign: 'Campaign',
  peopleLists: 'people lists',
  peopleListsNotCreated: 'You haven´t created any people list',
  peopleInTheList: 'People in the list',
  listName: 'List name',
  waitUntilTheListGetsCreated: 'Wait until the list get\'s created',
  loadingPeopleFromTheList: 'Loading people from the list',
  noPeopleInThisList: 'There aren\'t people in this list',
  rolesNotCreated: 'There aren´t created tags',
  code: 'Code',
  nameOfTheRol: 'Name of the tag',
  newRol: 'New tag',
  addNewRol: 'Add new tag',
  rolSuccessfullyCreated: 'Tag successfully created',
  editRol: 'Edit tag',
  rolSuccessfullyEdited: 'Tag successfully edited',
  columnsTable: 'columns',
  edit: 'Edit',
  loadingPerson: 'Loading person',
  weCouldNotFindThisPerson: 'We couldn\'t find this person',
  youMustAddKeyToUpdateUser: 'You should add a key to update this person',
  noDocumentsWereFoundForThisPerson: 'There aren\'t uploaded documents associated to this person',
  email: 'Email',
  verifyEmail: 'Verify Email',
  roles: 'Tags',
  updateAppPublicKey: 'Update app public key',
  emailSuccessfullyVerified: 'Email successfully verified',
  closeProfile: 'Close profile',
  journey: 'Journey',
  noJourneyForCurrentApp: 'Your application doesn\'t have an associated Journey, create one in order to add or change this person\'s current Journey status',
  changeJourneyCurrentStatus: 'Change this person\'s Journey current status',
  dependsOn: 'Depends on',
  journeyId: 'Journey ID',
  isDependencyOf: 'Is dependency of',
  changeJourneyCurrentStatusWarning: 'Are you sure to change this person Journey\' current status?',
  changeJourneyStatus: 'Change journey current status',
  customFields: 'Custom Fields',
  seeFilters: 'See filters',
  hideFilters: 'Hide filters',
  peopleFilters: 'People\'s filters',
  clearFields: 'Clear fields',
  startEditingMode: 'Start editing mode',
  stopEditingMode: 'Stop editing mode',
  createNewTaskToAssignInBlock: 'Create the new task to assign in block',
  taskCreatedSuccessfully: 'Task created successfully',
  chooseTheTypeOfBlockEdition: 'Begin by selecting the type of block editing that you want to do to start the process',
  modifyTheAdditionalDataThatYouWant: 'Modify the additional data that you want',
  justTheFilledExtraDataAreGoingToBeChanged: 'Only the extra data with some information filled are going to be edited, the rest of them are going to be ignored',
  pickTheJourneyStatusToAssignInBlock: 'Pick a Journey status to assign in block',
  editInBlock: 'Edit in block',
  enterInformation: 'Enter information',
  modifyAtLeastOneExtraDataToEditInBlock: 'You must modify at least one extra data in order to be able to edit in block',
  addAJourneyStatusToEditInBlock: 'You must add a Journey status in order to edit it in block',
  createAValidTaskToAddInBlock: 'You must create a valid task in order to add it in block',
  editPeopleInBlock: 'Edit people in block',
  aListWithThisNameAlreadyExists: 'A list with this name already exists',
  addTheNameOfTheListToBeCreated: 'Add the name of the list to be created',
  changeExtraData: 'Change additional information',
  pickAtLeastOneTypeOfEditingToEditInBlock: 'You must pick at least one type of editing and fill the corresponding information',
  editInBlockFinishedSuccessfully: 'Edit in block finished successfully',
  youMustAddTagsInOrderToFilterExtraData: 'You must add tags to extra data in order to filter it by tags',
  menu: 'Menu',
  of: 'of',
  responsible: 'Responsible',
  sendEmail: 'Send email',
  editResponsible: 'Edit Responsible',
  permissionsFor: 'Permissions for',
  // Importing people info
  numberOfRows: 'Number of rows',
  totalPeople: 'Total people',
  uniquePeople: 'Unique people',
  savedPeople: 'Saved people',
  updatedPeople: 'Updated people',
  insertedPeople: 'Inserted people',
  duplicatedPeople: 'Duplicated people',
  importCompleted: 'Import completed',
  importingBusinesses: 'Importing businesses',
  creatingList: 'Creating list',
  rol: 'Tag',
  businessInformationItems: 'Business information columns',
  personalInformationItems: 'Personal information columns',
  extraDataItems: 'Additional information columns',
  doYouWantToDeleteThisRol: 'Dou you really want to delete this rol?',
  rolSuccessfullyDeleted: 'Rol successfully deleted',
  addSelectedUsersToList: 'Add selected users to list',
  usersSuccessfullyAddedToList: 'Users successfully added to list'
}
